import { Injectable } from "@angular/core";
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";
import { Observable } from "rxjs";
import { CircularInjectionHelper } from "../services/circularInjectionHelper";
import { UserHelperService } from "../services/userHelper.service";
import { MatBottomSheet } from "@angular/material";
import { RouterHelperService } from "../services/routerHelper.service";
import { PopStateDirection } from "../shared/contentTypes";
import { Location } from "@angular/common";
import { LoginDialogComponent } from "../modalDialogs/logindialog/logindialog.component";
import { BottomSheetHelperService } from "../services/bottomSheetHelper.service";

@Injectable({
  providedIn: "root"
})
export class AuthGuard implements CanActivate {
  constructor(private _userHelperService: UserHelperService
    , private _routerHelperService: RouterHelperService
    , private _location: Location
    , private _bottomSheetHelperService: BottomSheetHelperService) {

  }
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    const me = this;
    const jumpRoutes = ["userprofile", "userprofiledetail", "changepassword"];
    if (me._userHelperService.IsRegistered) {
      return true;
    } else {
      // when use back button or forward in browser pass userprofile page
      if (me._routerHelperService.PopStateDirection !== PopStateDirection.Imprative && jumpRoutes.includes(next.routeConfig.path)) {
        if (me._routerHelperService.PopStateDirection === PopStateDirection.Backward) {
          me._location.back();
          return false;
        } else {
          me._location.forward();
          return false;
        }
      } else {
        const pageTitle = next.data ? next.data.pageTitle.label : "";
        me._bottomSheetHelperService.open(LoginDialogComponent);
        return false;
      }
    }
  }
}
